import CartDrawer from 'Common/CartDrawer';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { LayoutHook } from 'slices/layouts/hook';
import Footer from './Footer';
import Header from './Header';
import Sidebar from './VerticalLayout/Sidebar';

import {
  changeDirection,
  changeLayout,
  changeLayoutContentWidth,
  changeLayoutMode,
  changeLayoutSemiDark,
  changeLayoutTopbarColor,
  changeLeftSidebarColorType,
  // changeLeftsidebarSizeType,
  changeNavigation,
  changeSkin,
} from '../slices/thunk';

const Layout = ({ children }: any) => {
  const dispatch = useDispatch<any>();

  const [show, setShow] = React.useState<boolean>(false);
  const handleDrawer = () => setShow(!show);

  const {
    layoutType,
    layoutSemiDarkType,
    layoutSkintype,
    layoutModeType,
    layoutDirectionType,
    layoutContentWidthType,
    layoutNavigationType,
    layoutSidebarColorType,
    layoutTopbarColorType,
  } = LayoutHook();

  /*
    layout settings
    */
  useEffect(() => {
    if (
      layoutType ||
      layoutSemiDarkType ||
      layoutSkintype ||
      layoutModeType ||
      layoutDirectionType ||
      layoutContentWidthType ||
      // layoutSidebarSizeType ||
      layoutNavigationType ||
      layoutSidebarColorType ||
      layoutTopbarColorType
    ) {
      window.dispatchEvent(new Event('resize'));
      dispatch(changeLayout(layoutType));
      dispatch(changeLayoutSemiDark(layoutSemiDarkType));
      dispatch(changeSkin(layoutSkintype));
      dispatch(changeLayoutMode(layoutModeType));
      dispatch(changeDirection(layoutDirectionType));
      dispatch(changeLayoutContentWidth(layoutContentWidthType));
      // dispatch(changeLeftsidebarSizeType(layoutSidebarSizeType));
      dispatch(changeNavigation(layoutNavigationType));
      dispatch(changeLeftSidebarColorType(layoutSidebarColorType));
      dispatch(changeLayoutTopbarColor(layoutTopbarColorType));
    }
  }, [
    layoutType,
    layoutSemiDarkType,
    layoutSkintype,
    layoutModeType,
    layoutDirectionType,
    layoutContentWidthType,
    // layoutSidebarSizeType,
    layoutNavigationType,
    layoutSidebarColorType,
    layoutTopbarColorType,
    dispatch,
  ]);

  useEffect(() => {
    document.documentElement.classList.add('scroll-smooth', 'group');
    document.body.classList.add(
      'text-base',
      'text-body',
      'font-public',
      'dark:text-zink-100',
      'dark:bg-zink-800',
      'group-data-[skin=bordered]:bg-body-bordered',
      'group-data-[skin=bordered]:dark:bg-zink-700',
    );
    return () => {
      document.documentElement.classList.remove('scroll-smooth', 'group');
      document.body.classList.remove(
        'text-base',
        'text-body',
        'font-public',
        'dark:text-zink-100',
        'dark:bg-zink-800',
        'group-data-[skin=bordered]:bg-body-bordered',
        'group-data-[skin=bordered]:dark:bg-zink-700',
      );
    };
  }, []);

  // useEffect(() => {
  //   const windowSize = document.documentElement.clientWidth;
  //   if (windowSize >= 768) {
  //     document.body.classList.remove('overflow-hidden');
  //   }
  // }, [window.location.pathname]);

  return (
    <>
      <ToastContainer />
      <div className="group-data-[sidebar-size=sm]:min-h-sm group-data-[sidebar-size=sm]:relative">
        <Sidebar layoutType={layoutType} />
        <Header />
        <div className="relative min-h-screen group-data-[sidebar-size=sm]:min-h-sm">
          <div className="group-data-[sidebar-size=lg]:ltr:md:ml-vertical-menu group-data-[sidebar-size=lg]:rtl:md:mr-vertical-menu group-data-[sidebar-size=md]:ltr:ml-vertical-menu-md group-data-[sidebar-size=md]:rtl:mr-vertical-menu-md group-data-[sidebar-size=sm]:ltr:ml-vertical-menu-sm group-data-[sidebar-size=sm]:rtl:mr-vertical-menu-sm pt-[calc(theme('spacing.header')_*_1)] pb-[calc(theme('spacing.header')_*_0.8)] group-data-[navbar=bordered]:pt-[calc(theme('spacing.header')_*_1.3)] group-data-[navbar=hidden]:pt-0 group-data-[layout=horizontal]:mx-auto group-data-[layout=horizontal]:max-w-screen-2xl group-data-[layout=horizontal]:px-0 group-data-[layout=horizontal]:group-data-[sidebar-size=lg]:ltr:md:ml-auto group-data-[layout=horizontal]:group-data-[sidebar-size=lg]:rtl:md:mr-auto group-data-[layout=horizontal]:md:pt-[calc(theme('spacing.header')_*_1.8)] group-data-[layout=horizontal]:px-3 group-data-[layout=horizontal]:group-data-[navbar=hidden]:pt-[calc(theme('spacing.header')_*_0.9)]">
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto min-h-[calc(100vh-126px)] bg-white dark:bg-zink-800 px-4 sm:px-8 py-4">
              {children}
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <CartDrawer show={show} handleDrawer={handleDrawer} />
    </>
  );
};

export default Layout;
